import { _ as re } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { o as ct } from "./es.object.assign-7e79fd7b.js";
import { c as te } from "./index-8b07dec9.js";
import { useMemo as ae, useRef as ft } from "react";
import ht, { css as vt } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import { useClient as ge } from "./useClient.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import { a as pt, c as mt } from "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import { f as Er } from "./es.object.to-string-f55666a8.js";
import { s as gt } from "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { P as dt } from "./popupTip-06ee114c.js";
import "./es.string.starts-with-a6645e0a.js";
import { d as St } from "./index-5d0f31c6.js";
import "./es.string.link-fd2676c6.js";
import { jsx as N } from "react/jsx-runtime";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import { f as wt, E as kr, q as Ve, b as de, _ as Se, O as Rt, g as xr, G as Pt, d as Hr, e as br, C as Lt, D as It, U as yt, j as Or, s as Nr, k as Ut } from "./export-cdcbfb2b.js";
import { i as Tt } from "./is-pure-c0f11fe0.js";
import { d as _r } from "./define-built-in-accessor-26bc7b69.js";
import { a as Fr } from "./an-instance-6efcfd6c.js";
import { a as $t } from "./es.array.from-fe752fa6.js";
import { a as Ct } from "./array-slice-79f93c56.js";
import { t as Dr } from "./to-string-92a62764.js";
import { s as Br, g as At, b as Et } from "./iterate-13ada9e5.js";
import { v as jr } from "./validate-arguments-length-eb516e5b.js";
import { s as kt } from "./safe-get-built-in-a8d8c20c.js";
import { c as xt } from "./classof-21a3574e.js";
import { o as Ht } from "./object-create-9b6715a2.js";
import { a as bt } from "./array-sort-7c90b530.js";
import { i as qr } from "./isApiSupported-66660265.js";
import { i as Mr } from "./isClient-2f5bedbd.js";
import { IconButton as Ot } from "./iconButton.js";
import { Tooltip as Nt } from "./tooltip.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./aria.js";
import "./getMetrics-953aa4f8.js";
import "./useWindowSize.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./string-trim-14e37ad3.js";
import "./string-html-forced-a746405b.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
var _t = wt, Ft = kr, Dt = Ve, Ze = Tt, Bt = Ft("iterator"), zr = !_t(function() {
  var e = new URL("b?a=1&b=2&c=3", "https://a"), a = e.searchParams, t = new URLSearchParams("a=1&a=2&b=3"), r = "";
  return e.pathname = "c%20d", a.forEach(function(n, s) {
    a.delete("b"), r += s + n;
  }), t.delete("a", 2), t.delete("b", void 0), Ze && (!e.toJSON || !t.has("a", 1) || t.has("a", 2) || !t.has("a", void 0) || t.has("b")) || !a.size && (Ze || !Dt) || !a.sort || e.href !== "https://a/c%20d?a=1&c=3" || a.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !a[Bt] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || r !== "a1c3" || new URL("https://x", void 0).host !== "x";
}), _ = de, Le = 2147483647, Q = 36, Gr = 1, je = 26, jt = 38, qt = 700, Mt = 72, zt = 128, Gt = "-", Vt = /[^\0-\u007E]/, Vr = /[.\u3002\uFF0E\uFF61]/g, er = "Overflow: input needs wider integers to process", Ie = Q - Gr, rr = RangeError, Kt = _(Vr.exec), M = Math.floor, ye = String.fromCharCode, tr = _("".charCodeAt), Kr = _([].join), E = _([].push), Yt = _("".replace), Wt = _("".split), Jt = _("".toLowerCase), Qt = function(e) {
  for (var a = [], t = 0, r = e.length; t < r; ) {
    var n = tr(e, t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var s = tr(e, t++);
      (s & 64512) === 56320 ? E(a, ((n & 1023) << 10) + (s & 1023) + 65536) : (E(a, n), t--);
    } else
      E(a, n);
  }
  return a;
}, ar = function(e) {
  return e + 22 + 75 * (e < 26);
}, Xt = function(e, a, t) {
  var r = 0;
  for (e = t ? M(e / qt) : e >> 1, e += M(e / a); e > Ie * je >> 1; )
    e = M(e / Ie), r += Q;
  return M(r + (Ie + 1) * e / (e + jt));
}, Zt = function(e) {
  var a = [];
  e = Qt(e);
  var t = e.length, r = zt, n = 0, s = Mt, i, l;
  for (i = 0; i < e.length; i++)
    l = e[i], l < 128 && E(a, ye(l));
  var u = a.length, c = u;
  for (u && E(a, Gt); c < t; ) {
    var h = Le;
    for (i = 0; i < e.length; i++)
      l = e[i], l >= r && l < h && (h = l);
    var o = c + 1;
    if (h - r > M((Le - n) / o))
      throw new rr(er);
    for (n += (h - r) * o, r = h, i = 0; i < e.length; i++) {
      if (l = e[i], l < r && ++n > Le)
        throw new rr(er);
      if (l === r) {
        for (var f = n, v = Q; ; ) {
          var L = v <= s ? Gr : v >= s + je ? je : v - s;
          if (f < L)
            break;
          var x = f - L, H = Q - L;
          E(a, ye(ar(L + x % H))), f = M(x / H), v += Q;
        }
        E(a, ye(ar(f))), s = Xt(n, o, c === u), n = 0, c++;
      }
    }
    n++, r++;
  }
  return Kr(a, "");
}, ea = function(e) {
  var a = [], t = Wt(Yt(Jt(e), Vr, "."), "."), r, n;
  for (r = 0; r < t.length; r++)
    n = t[r], E(a, Kt(Vt, n) ? "xn--" + Zt(n) : n);
  return Kr(a, ".");
}, ra = Se, ta = de, aa = Rt, na = RangeError, nr = String.fromCharCode, ir = String.fromCodePoint, ia = ta([].join), sa = !!ir && ir.length !== 1;
ra({ target: "String", stat: !0, arity: 1, forced: sa }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function(a) {
    for (var t = [], r = arguments.length, n = 0, s; r > n; ) {
      if (s = +arguments[n++], aa(s, 1114111) !== s)
        throw new na(s + " is not a valid code point");
      t[n] = s < 65536 ? nr(s) : nr(((s -= 65536) >> 10) + 55296, s % 1024 + 56320);
    }
    return ia(t, "");
  }
});
var qe = Se, Yr = xr, Ke = kt, oa = Pt, ne = Or, U = de, X = Ve, Wr = zr, Jr = Hr, la = _r, ua = St, ca = Br, fa = pt, Ye = br, Qr = Fr, Ue = Lt, ha = Nr, va = Er, pa = xt, ma = Ut, Xr = It, m = Dr, ga = Ht, sr = yt, or = At, da = Et, ie = mt, D = jr, Sa = kr, wa = bt, Ra = Sa("iterator"), V = "URLSearchParams", Zr = V + "Iterator", et = Ye.set, w = Ye.getterFor(V), Pa = Ye.getterFor(Zr), lr = Ke("fetch"), fe = Ke("Request"), Z = Ke("Headers"), Te = fe && fe.prototype, ur = Z && Z.prototype, La = Yr.TypeError, Ia = Yr.encodeURIComponent, ya = String.fromCharCode, Ua = oa("String", "fromCodePoint"), Ta = parseInt, ue = U("".charAt), cr = U([].join), k = U([].push), rt = U("".replace), $a = U([].shift), fr = U([].splice), hr = U("".split), tt = U("".slice), Ca = U(/./.exec), Aa = /\+/g, $e = "�", Ea = /^[0-9a-f]+$/i, vr = function(e, a) {
  var t = tt(e, a, a + 2);
  return Ca(Ea, t) ? Ta(t, 16) : NaN;
}, ka = function(e) {
  for (var a = 0, t = 128; t > 0 && e & t; t >>= 1)
    a++;
  return a;
}, xa = function(e) {
  var a = null;
  switch (e.length) {
    case 1:
      a = e[0];
      break;
    case 2:
      a = (e[0] & 31) << 6 | e[1] & 63;
      break;
    case 3:
      a = (e[0] & 15) << 12 | (e[1] & 63) << 6 | e[2] & 63;
      break;
    case 4:
      a = (e[0] & 7) << 18 | (e[1] & 63) << 12 | (e[2] & 63) << 6 | e[3] & 63;
      break;
  }
  return a > 1114111 ? null : a;
}, pr = function(e) {
  e = rt(e, Aa, " ");
  for (var a = e.length, t = "", r = 0; r < a; ) {
    var n = ue(e, r);
    if (n === "%") {
      if (ue(e, r + 1) === "%" || r + 3 > a) {
        t += "%", r++;
        continue;
      }
      var s = vr(e, r + 1);
      if (s !== s) {
        t += n, r++;
        continue;
      }
      r += 2;
      var i = ka(s);
      if (i === 0)
        n = ya(s);
      else {
        if (i === 1 || i > 4) {
          t += $e, r++;
          continue;
        }
        for (var l = [s], u = 1; u < i && (r++, !(r + 3 > a || ue(e, r) !== "%")); ) {
          var c = vr(e, r + 1);
          if (c !== c) {
            r += 3;
            break;
          }
          if (c > 191 || c < 128)
            break;
          k(l, c), r += 2, u++;
        }
        if (l.length !== i) {
          t += $e;
          continue;
        }
        var h = xa(l);
        h === null ? t += $e : n = Ua(h);
      }
    }
    t += n, r++;
  }
  return t;
}, Ha = /[!'()~]|%20/g, ba = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "~": "%7E",
  "%20": "+"
}, Oa = function(e) {
  return ba[e];
}, mr = function(e) {
  return rt(Ia(e), Ha, Oa);
}, Ce = fa(function(a, t) {
  et(this, {
    type: Zr,
    target: w(a).entries,
    index: 0,
    kind: t
  });
}, V, function() {
  var a = Pa(this), t = a.target, r = a.index++;
  if (!t || r >= t.length)
    return a.target = null, ie(void 0, !0);
  var n = t[r];
  switch (a.kind) {
    case "keys":
      return ie(n.key, !1);
    case "values":
      return ie(n.value, !1);
  }
  return ie([n.key, n.value], !1);
}, !0), at = function(e) {
  this.entries = [], this.url = null, e !== void 0 && (Xr(e) ? this.parseObject(e) : this.parseQuery(typeof e == "string" ? ue(e, 0) === "?" ? tt(e, 1) : e : m(e)));
};
at.prototype = {
  type: V,
  bindURL: function(e) {
    this.url = e, this.update();
  },
  parseObject: function(e) {
    var a = this.entries, t = da(e), r, n, s, i, l, u, c;
    if (t)
      for (r = or(e, t), n = r.next; !(s = ne(n, r)).done; ) {
        if (i = or(ma(s.value)), l = i.next, (u = ne(l, i)).done || (c = ne(l, i)).done || !ne(l, i).done)
          throw new La("Expected sequence with length 2");
        k(a, { key: m(u.value), value: m(c.value) });
      }
    else
      for (var h in e)
        ha(e, h) && k(a, { key: h, value: m(e[h]) });
  },
  parseQuery: function(e) {
    if (e)
      for (var a = this.entries, t = hr(e, "&"), r = 0, n, s; r < t.length; )
        n = t[r++], n.length && (s = hr(n, "="), k(a, {
          key: pr($a(s)),
          value: pr(cr(s, "="))
        }));
  },
  serialize: function() {
    for (var e = this.entries, a = [], t = 0, r; t < e.length; )
      r = e[t++], k(a, mr(r.key) + "=" + mr(r.value));
    return cr(a, "&");
  },
  update: function() {
    this.entries.length = 0, this.parseQuery(this.url.query);
  },
  updateURL: function() {
    this.url && this.url.update();
  }
};
var we = function() {
  Qr(this, z);
  var a = arguments.length > 0 ? arguments[0] : void 0, t = et(this, new at(a));
  X || (this.size = t.entries.length);
}, z = we.prototype;
ua(z, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function(a, t) {
    var r = w(this);
    D(arguments.length, 2), k(r.entries, { key: m(a), value: m(t) }), X || this.length++, r.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  delete: function(e) {
    for (var a = w(this), t = D(arguments.length, 1), r = a.entries, n = m(e), s = t < 2 ? void 0 : arguments[1], i = s === void 0 ? s : m(s), l = 0; l < r.length; ) {
      var u = r[l];
      if (u.key === n && (i === void 0 || u.value === i)) {
        if (fr(r, l, 1), i !== void 0)
          break;
      } else
        l++;
    }
    X || (this.size = r.length), a.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function(a) {
    var t = w(this).entries;
    D(arguments.length, 1);
    for (var r = m(a), n = 0; n < t.length; n++)
      if (t[n].key === r)
        return t[n].value;
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function(a) {
    var t = w(this).entries;
    D(arguments.length, 1);
    for (var r = m(a), n = [], s = 0; s < t.length; s++)
      t[s].key === r && k(n, t[s].value);
    return n;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function(a) {
    for (var t = w(this).entries, r = D(arguments.length, 1), n = m(a), s = r < 2 ? void 0 : arguments[1], i = s === void 0 ? s : m(s), l = 0; l < t.length; ) {
      var u = t[l++];
      if (u.key === n && (i === void 0 || u.value === i))
        return !0;
    }
    return !1;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function(a, t) {
    var r = w(this);
    D(arguments.length, 1);
    for (var n = r.entries, s = !1, i = m(a), l = m(t), u = 0, c; u < n.length; u++)
      c = n[u], c.key === i && (s ? fr(n, u--, 1) : (s = !0, c.value = l));
    s || k(n, { key: i, value: l }), X || (this.size = n.length), r.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function() {
    var a = w(this);
    wa(a.entries, function(t, r) {
      return t.key > r.key ? 1 : -1;
    }), a.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function(a) {
    for (var t = w(this).entries, r = va(a, arguments.length > 1 ? arguments[1] : void 0), n = 0, s; n < t.length; )
      s = t[n++], r(s.value, s.key, this);
  },
  // `URLSearchParams.prototype.keys` method
  keys: function() {
    return new Ce(this, "keys");
  },
  // `URLSearchParams.prototype.values` method
  values: function() {
    return new Ce(this, "values");
  },
  // `URLSearchParams.prototype.entries` method
  entries: function() {
    return new Ce(this, "entries");
  }
}, { enumerable: !0 });
Jr(z, Ra, z.entries, { name: "entries" });
Jr(z, "toString", function() {
  return w(this).serialize();
}, { enumerable: !0 });
X && la(z, "size", {
  get: function() {
    return w(this).entries.length;
  },
  configurable: !0,
  enumerable: !0
});
ca(we, V);
qe({ global: !0, constructor: !0, forced: !Wr }, {
  URLSearchParams: we
});
if (!Wr && Ue(Z)) {
  var Na = U(ur.has), _a = U(ur.set), gr = function(e) {
    if (Xr(e)) {
      var a = e.body, t;
      if (pa(a) === V)
        return t = e.headers ? new Z(e.headers) : new Z(), Na(t, "content-type") || _a(t, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), ga(e, {
          body: sr(0, m(a)),
          headers: sr(0, t)
        });
    }
    return e;
  };
  if (Ue(lr) && qe({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
    fetch: function(a) {
      return lr(a, arguments.length > 1 ? gr(arguments[1]) : {});
    }
  }), Ue(fe)) {
    var Ae = function(a) {
      return Qr(this, Te), new fe(a, arguments.length > 1 ? gr(arguments[1]) : {});
    };
    Te.constructor = Ae, Ae.prototype = Te, qe({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
      Request: Ae
    });
  }
}
var Fa = {
  URLSearchParams: we,
  getState: w
}, Da = Se, We = Ve, Ba = zr, Je = xr, dr = Er, P = de, he = Hr, g = _r, ja = Fr, Me = Nr, Qe = ct, B = $t, I = Ct, qa = gt.codeAt, Ma = ea, C = Dr, za = Br, Ga = jr, nt = Fa, it = br, Va = it.set, ve = it.getterFor("URL"), Ka = nt.URLSearchParams, Ya = nt.getState, K = Je.URL, ze = Je.TypeError, pe = Je.parseInt, Wa = Math.floor, Sr = Math.pow, R = P("".charAt), y = P(/./.exec), W = P([].join), Ja = P(1 .toString), Qa = P([].pop), q = P([].push), Ee = P("".replace), Xa = P([].shift), Za = P("".split), ee = P("".slice), me = P("".toLowerCase), en = P([].unshift), rn = "Invalid authority", ke = "Invalid scheme", b = "Invalid host", wr = "Invalid port", st = /[a-z]/i, tn = /[\d+-.a-z]/i, Ge = /\d/, an = /^0x/i, nn = /^[0-7]+$/, sn = /^\d+$/, ot = /^[\da-f]+$/i, on = /[\0\t\n\r #%/:<>?@[\\\]^|]/, ln = /[\0\t\n\r #/:<>?@[\\\]^|]/, un = /^[\u0000-\u0020]+/, cn = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, fn = /[\t\n\r]/g, d, hn = function(e) {
  var a = Za(e, "."), t, r, n, s, i, l, u;
  if (a.length && a[a.length - 1] === "" && a.length--, t = a.length, t > 4)
    return e;
  for (r = [], n = 0; n < t; n++) {
    if (s = a[n], s === "")
      return e;
    if (i = 10, s.length > 1 && R(s, 0) === "0" && (i = y(an, s) ? 16 : 8, s = ee(s, i === 8 ? 1 : 2)), s === "")
      l = 0;
    else {
      if (!y(i === 10 ? sn : i === 8 ? nn : ot, s))
        return e;
      l = pe(s, i);
    }
    q(r, l);
  }
  for (n = 0; n < t; n++)
    if (l = r[n], n === t - 1) {
      if (l >= Sr(256, 5 - t))
        return null;
    } else if (l > 255)
      return null;
  for (u = Qa(r), n = 0; n < r.length; n++)
    u += r[n] * Sr(256, 3 - n);
  return u;
}, vn = function(e) {
  var a = [0, 0, 0, 0, 0, 0, 0, 0], t = 0, r = null, n = 0, s, i, l, u, c, h, o, f = function() {
    return R(e, n);
  };
  if (f() === ":") {
    if (R(e, 1) !== ":")
      return;
    n += 2, t++, r = t;
  }
  for (; f(); ) {
    if (t === 8)
      return;
    if (f() === ":") {
      if (r !== null)
        return;
      n++, t++, r = t;
      continue;
    }
    for (s = i = 0; i < 4 && y(ot, f()); )
      s = s * 16 + pe(f(), 16), n++, i++;
    if (f() === ".") {
      if (i === 0 || (n -= i, t > 6))
        return;
      for (l = 0; f(); ) {
        if (u = null, l > 0)
          if (f() === "." && l < 4)
            n++;
          else
            return;
        if (!y(Ge, f()))
          return;
        for (; y(Ge, f()); ) {
          if (c = pe(f(), 10), u === null)
            u = c;
          else {
            if (u === 0)
              return;
            u = u * 10 + c;
          }
          if (u > 255)
            return;
          n++;
        }
        a[t] = a[t] * 256 + u, l++, (l === 2 || l === 4) && t++;
      }
      if (l !== 4)
        return;
      break;
    } else if (f() === ":") {
      if (n++, !f())
        return;
    } else if (f())
      return;
    a[t++] = s;
  }
  if (r !== null)
    for (h = t - r, t = 7; t !== 0 && h > 0; )
      o = a[t], a[t--] = a[r + h - 1], a[r + --h] = o;
  else if (t !== 8)
    return;
  return a;
}, pn = function(e) {
  for (var a = null, t = 1, r = null, n = 0, s = 0; s < 8; s++)
    e[s] !== 0 ? (n > t && (a = r, t = n), r = null, n = 0) : (r === null && (r = s), ++n);
  return n > t ? r : a;
}, Y = function(e) {
  var a, t, r, n;
  if (typeof e == "number") {
    for (a = [], t = 0; t < 4; t++)
      en(a, e % 256), e = Wa(e / 256);
    return W(a, ".");
  }
  if (typeof e == "object") {
    for (a = "", r = pn(e), t = 0; t < 8; t++)
      n && e[t] === 0 || (n && (n = !1), r === t ? (a += t ? ":" : "::", n = !0) : (a += Ja(e[t], 16), t < 7 && (a += ":")));
    return "[" + a + "]";
  }
  return e;
}, ce = {}, lt = Qe({}, ce, {
  " ": 1,
  '"': 1,
  "<": 1,
  ">": 1,
  "`": 1
}), ut = Qe({}, lt, {
  "#": 1,
  "?": 1,
  "{": 1,
  "}": 1
}), xe = Qe({}, ut, {
  "/": 1,
  ":": 1,
  ";": 1,
  "=": 1,
  "@": 1,
  "[": 1,
  "\\": 1,
  "]": 1,
  "^": 1,
  "|": 1
}), A = function(e, a) {
  var t = qa(e, 0);
  return t > 32 && t < 127 && !Me(a, e) ? e : encodeURIComponent(e);
}, se = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}, J = function(e, a) {
  var t;
  return e.length === 2 && y(st, R(e, 0)) && ((t = R(e, 1)) === ":" || !a && t === "|");
}, Rr = function(e) {
  var a;
  return e.length > 1 && J(ee(e, 0, 2)) && (e.length === 2 || (a = R(e, 2)) === "/" || a === "\\" || a === "?" || a === "#");
}, mn = function(e) {
  return e === "." || me(e) === "%2e";
}, gn = function(e) {
  return e = me(e), e === ".." || e === "%2e." || e === ".%2e" || e === "%2e%2e";
}, He = {}, Pr = {}, be = {}, Lr = {}, Ir = {}, Oe = {}, yr = {}, Ur = {}, oe = {}, le = {}, Ne = {}, _e = {}, Fe = {}, De = {}, Tr = {}, Be = {}, j = {}, T = {}, $r = {}, O = {}, $ = {}, Xe = function(e, a, t) {
  var r = C(e), n, s, i;
  if (a) {
    if (s = this.parse(r), s)
      throw new ze(s);
    this.searchParams = null;
  } else {
    if (t !== void 0 && (n = new Xe(t, !0)), s = this.parse(r, null, n), s)
      throw new ze(s);
    i = Ya(new Ka()), i.bindURL(this), this.searchParams = i;
  }
};
Xe.prototype = {
  type: "URL",
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function(e, a, t) {
    var r = this, n = a || He, s = 0, i = "", l = !1, u = !1, c = !1, h, o, f, v;
    for (e = C(e), a || (r.scheme = "", r.username = "", r.password = "", r.host = null, r.port = null, r.path = [], r.query = null, r.fragment = null, r.cannotBeABaseURL = !1, e = Ee(e, un, ""), e = Ee(e, cn, "$1")), e = Ee(e, fn, ""), h = B(e); s <= h.length; ) {
      switch (o = h[s], n) {
        case He:
          if (o && y(st, o))
            i += me(o), n = Pr;
          else {
            if (a)
              return ke;
            n = be;
            continue;
          }
          break;
        case Pr:
          if (o && (y(tn, o) || o === "+" || o === "-" || o === "."))
            i += me(o);
          else if (o === ":") {
            if (a && (r.isSpecial() !== Me(se, i) || i === "file" && (r.includesCredentials() || r.port !== null) || r.scheme === "file" && !r.host))
              return;
            if (r.scheme = i, a) {
              r.isSpecial() && se[r.scheme] === r.port && (r.port = null);
              return;
            }
            i = "", r.scheme === "file" ? n = De : r.isSpecial() && t && t.scheme === r.scheme ? n = Lr : r.isSpecial() ? n = Ur : h[s + 1] === "/" ? (n = Ir, s++) : (r.cannotBeABaseURL = !0, q(r.path, ""), n = $r);
          } else {
            if (a)
              return ke;
            i = "", n = be, s = 0;
            continue;
          }
          break;
        case be:
          if (!t || t.cannotBeABaseURL && o !== "#")
            return ke;
          if (t.cannotBeABaseURL && o === "#") {
            r.scheme = t.scheme, r.path = I(t.path), r.query = t.query, r.fragment = "", r.cannotBeABaseURL = !0, n = $;
            break;
          }
          n = t.scheme === "file" ? De : Oe;
          continue;
        case Lr:
          if (o === "/" && h[s + 1] === "/")
            n = oe, s++;
          else {
            n = Oe;
            continue;
          }
          break;
        case Ir:
          if (o === "/") {
            n = le;
            break;
          } else {
            n = T;
            continue;
          }
        case Oe:
          if (r.scheme = t.scheme, o === d)
            r.username = t.username, r.password = t.password, r.host = t.host, r.port = t.port, r.path = I(t.path), r.query = t.query;
          else if (o === "/" || o === "\\" && r.isSpecial())
            n = yr;
          else if (o === "?")
            r.username = t.username, r.password = t.password, r.host = t.host, r.port = t.port, r.path = I(t.path), r.query = "", n = O;
          else if (o === "#")
            r.username = t.username, r.password = t.password, r.host = t.host, r.port = t.port, r.path = I(t.path), r.query = t.query, r.fragment = "", n = $;
          else {
            r.username = t.username, r.password = t.password, r.host = t.host, r.port = t.port, r.path = I(t.path), r.path.length--, n = T;
            continue;
          }
          break;
        case yr:
          if (r.isSpecial() && (o === "/" || o === "\\"))
            n = oe;
          else if (o === "/")
            n = le;
          else {
            r.username = t.username, r.password = t.password, r.host = t.host, r.port = t.port, n = T;
            continue;
          }
          break;
        case Ur:
          if (n = oe, o !== "/" || R(i, s + 1) !== "/")
            continue;
          s++;
          break;
        case oe:
          if (o !== "/" && o !== "\\") {
            n = le;
            continue;
          }
          break;
        case le:
          if (o === "@") {
            l && (i = "%40" + i), l = !0, f = B(i);
            for (var L = 0; L < f.length; L++) {
              var x = f[L];
              if (x === ":" && !c) {
                c = !0;
                continue;
              }
              var H = A(x, xe);
              c ? r.password += H : r.username += H;
            }
            i = "";
          } else if (o === d || o === "/" || o === "?" || o === "#" || o === "\\" && r.isSpecial()) {
            if (l && i === "")
              return rn;
            s -= B(i).length + 1, i = "", n = Ne;
          } else
            i += o;
          break;
        case Ne:
        case _e:
          if (a && r.scheme === "file") {
            n = Be;
            continue;
          } else if (o === ":" && !u) {
            if (i === "")
              return b;
            if (v = r.parseHost(i), v)
              return v;
            if (i = "", n = Fe, a === _e)
              return;
          } else if (o === d || o === "/" || o === "?" || o === "#" || o === "\\" && r.isSpecial()) {
            if (r.isSpecial() && i === "")
              return b;
            if (a && i === "" && (r.includesCredentials() || r.port !== null))
              return;
            if (v = r.parseHost(i), v)
              return v;
            if (i = "", n = j, a)
              return;
            continue;
          } else
            o === "[" ? u = !0 : o === "]" && (u = !1), i += o;
          break;
        case Fe:
          if (y(Ge, o))
            i += o;
          else if (o === d || o === "/" || o === "?" || o === "#" || o === "\\" && r.isSpecial() || a) {
            if (i !== "") {
              var Pe = pe(i, 10);
              if (Pe > 65535)
                return wr;
              r.port = r.isSpecial() && Pe === se[r.scheme] ? null : Pe, i = "";
            }
            if (a)
              return;
            n = j;
            continue;
          } else
            return wr;
          break;
        case De:
          if (r.scheme = "file", o === "/" || o === "\\")
            n = Tr;
          else if (t && t.scheme === "file")
            switch (o) {
              case d:
                r.host = t.host, r.path = I(t.path), r.query = t.query;
                break;
              case "?":
                r.host = t.host, r.path = I(t.path), r.query = "", n = O;
                break;
              case "#":
                r.host = t.host, r.path = I(t.path), r.query = t.query, r.fragment = "", n = $;
                break;
              default:
                Rr(W(I(h, s), "")) || (r.host = t.host, r.path = I(t.path), r.shortenPath()), n = T;
                continue;
            }
          else {
            n = T;
            continue;
          }
          break;
        case Tr:
          if (o === "/" || o === "\\") {
            n = Be;
            break;
          }
          t && t.scheme === "file" && !Rr(W(I(h, s), "")) && (J(t.path[0], !0) ? q(r.path, t.path[0]) : r.host = t.host), n = T;
          continue;
        case Be:
          if (o === d || o === "/" || o === "\\" || o === "?" || o === "#") {
            if (!a && J(i))
              n = T;
            else if (i === "") {
              if (r.host = "", a)
                return;
              n = j;
            } else {
              if (v = r.parseHost(i), v)
                return v;
              if (r.host === "localhost" && (r.host = ""), a)
                return;
              i = "", n = j;
            }
            continue;
          } else
            i += o;
          break;
        case j:
          if (r.isSpecial()) {
            if (n = T, o !== "/" && o !== "\\")
              continue;
          } else if (!a && o === "?")
            r.query = "", n = O;
          else if (!a && o === "#")
            r.fragment = "", n = $;
          else if (o !== d && (n = T, o !== "/"))
            continue;
          break;
        case T:
          if (o === d || o === "/" || o === "\\" && r.isSpecial() || !a && (o === "?" || o === "#")) {
            if (gn(i) ? (r.shortenPath(), o !== "/" && !(o === "\\" && r.isSpecial()) && q(r.path, "")) : mn(i) ? o !== "/" && !(o === "\\" && r.isSpecial()) && q(r.path, "") : (r.scheme === "file" && !r.path.length && J(i) && (r.host && (r.host = ""), i = R(i, 0) + ":"), q(r.path, i)), i = "", r.scheme === "file" && (o === d || o === "?" || o === "#"))
              for (; r.path.length > 1 && r.path[0] === ""; )
                Xa(r.path);
            o === "?" ? (r.query = "", n = O) : o === "#" && (r.fragment = "", n = $);
          } else
            i += A(o, ut);
          break;
        case $r:
          o === "?" ? (r.query = "", n = O) : o === "#" ? (r.fragment = "", n = $) : o !== d && (r.path[0] += A(o, ce));
          break;
        case O:
          !a && o === "#" ? (r.fragment = "", n = $) : o !== d && (o === "'" && r.isSpecial() ? r.query += "%27" : o === "#" ? r.query += "%23" : r.query += A(o, ce));
          break;
        case $:
          o !== d && (r.fragment += A(o, lt));
          break;
      }
      s++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function(e) {
    var a, t, r;
    if (R(e, 0) === "[") {
      if (R(e, e.length - 1) !== "]" || (a = vn(ee(e, 1, -1)), !a))
        return b;
      this.host = a;
    } else if (this.isSpecial()) {
      if (e = Ma(e), y(on, e) || (a = hn(e), a === null))
        return b;
      this.host = a;
    } else {
      if (y(ln, e))
        return b;
      for (a = "", t = B(e), r = 0; r < t.length; r++)
        a += A(t[r], ce);
      this.host = a;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function() {
    return !this.host || this.cannotBeABaseURL || this.scheme === "file";
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function() {
    return this.username !== "" || this.password !== "";
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function() {
    return Me(se, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function() {
    var e = this.path, a = e.length;
    a && (this.scheme !== "file" || a !== 1 || !J(e[0], !0)) && e.length--;
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function() {
    var e = this, a = e.scheme, t = e.username, r = e.password, n = e.host, s = e.port, i = e.path, l = e.query, u = e.fragment, c = a + ":";
    return n !== null ? (c += "//", e.includesCredentials() && (c += t + (r ? ":" + r : "") + "@"), c += Y(n), s !== null && (c += ":" + s)) : a === "file" && (c += "//"), c += e.cannotBeABaseURL ? i[0] : i.length ? "/" + W(i, "/") : "", l !== null && (c += "?" + l), u !== null && (c += "#" + u), c;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function(e) {
    var a = this.parse(e);
    if (a)
      throw new ze(a);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function() {
    var e = this.scheme, a = this.port;
    if (e === "blob")
      try {
        return new G(e.path[0]).origin;
      } catch {
        return "null";
      }
    return e === "file" || !this.isSpecial() ? "null" : e + "://" + Y(this.host) + (a !== null ? ":" + a : "");
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function() {
    return this.scheme + ":";
  },
  setProtocol: function(e) {
    this.parse(C(e) + ":", He);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function() {
    return this.username;
  },
  setUsername: function(e) {
    var a = B(C(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.username = "";
      for (var t = 0; t < a.length; t++)
        this.username += A(a[t], xe);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function() {
    return this.password;
  },
  setPassword: function(e) {
    var a = B(C(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.password = "";
      for (var t = 0; t < a.length; t++)
        this.password += A(a[t], xe);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function() {
    var e = this.host, a = this.port;
    return e === null ? "" : a === null ? Y(e) : Y(e) + ":" + a;
  },
  setHost: function(e) {
    this.cannotBeABaseURL || this.parse(e, Ne);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function() {
    var e = this.host;
    return e === null ? "" : Y(e);
  },
  setHostname: function(e) {
    this.cannotBeABaseURL || this.parse(e, _e);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function() {
    var e = this.port;
    return e === null ? "" : C(e);
  },
  setPort: function(e) {
    this.cannotHaveUsernamePasswordPort() || (e = C(e), e === "" ? this.port = null : this.parse(e, Fe));
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function() {
    var e = this.path;
    return this.cannotBeABaseURL ? e[0] : e.length ? "/" + W(e, "/") : "";
  },
  setPathname: function(e) {
    this.cannotBeABaseURL || (this.path = [], this.parse(e, j));
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function() {
    var e = this.query;
    return e ? "?" + e : "";
  },
  setSearch: function(e) {
    e = C(e), e === "" ? this.query = null : (R(e, 0) === "?" && (e = ee(e, 1)), this.query = "", this.parse(e, O)), this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function() {
    var e = this.fragment;
    return e ? "#" + e : "";
  },
  setHash: function(e) {
    if (e = C(e), e === "") {
      this.fragment = null;
      return;
    }
    R(e, 0) === "#" && (e = ee(e, 1)), this.fragment = "", this.parse(e, $);
  },
  update: function() {
    this.query = this.searchParams.serialize() || null;
  }
};
var G = function(a) {
  var t = ja(this, p), r = Ga(arguments.length, 1) > 1 ? arguments[1] : void 0, n = Va(t, new Xe(a, !1, r));
  We || (t.href = n.serialize(), t.origin = n.getOrigin(), t.protocol = n.getProtocol(), t.username = n.getUsername(), t.password = n.getPassword(), t.host = n.getHost(), t.hostname = n.getHostname(), t.port = n.getPort(), t.pathname = n.getPathname(), t.search = n.getSearch(), t.searchParams = n.getSearchParams(), t.hash = n.getHash());
}, p = G.prototype, S = function(e, a) {
  return {
    get: function() {
      return ve(this)[e]();
    },
    set: a && function(t) {
      return ve(this)[a](t);
    },
    configurable: !0,
    enumerable: !0
  };
};
We && (g(p, "href", S("serialize", "setHref")), g(p, "origin", S("getOrigin")), g(p, "protocol", S("getProtocol", "setProtocol")), g(p, "username", S("getUsername", "setUsername")), g(p, "password", S("getPassword", "setPassword")), g(p, "host", S("getHost", "setHost")), g(p, "hostname", S("getHostname", "setHostname")), g(p, "port", S("getPort", "setPort")), g(p, "pathname", S("getPathname", "setPathname")), g(p, "search", S("getSearch", "setSearch")), g(p, "searchParams", S("getSearchParams")), g(p, "hash", S("getHash", "setHash")));
he(p, "toJSON", function() {
  return ve(this).serialize();
}, { enumerable: !0 });
he(p, "toString", function() {
  return ve(this).serialize();
}, { enumerable: !0 });
if (K) {
  var Cr = K.createObjectURL, Ar = K.revokeObjectURL;
  Cr && he(G, "createObjectURL", dr(Cr, K)), Ar && he(G, "revokeObjectURL", dr(Ar, K));
}
za(G, "URL");
Da({ global: !0, constructor: !0, forced: !Ba, sham: !We }, {
  URL: G
});
var dn = Se, Sn = Or;
dn({ target: "URL", proto: !0, enumerable: !0 }, {
  toJSON: function() {
    return Sn(URL.prototype.toString, this);
  }
});
var wn = ["pageUrl", "params", "className"], Rn = ["pageUrl", "params", "className"], Pn = ["pageUrl", "params", "className"], Ln = function(a) {
  var t, r = a.pageUrl, n = a.params, s = a.className, i = re(a, wn), l = ge(), u = ae(function() {
    return r || Re();
  }, [r]);
  return /* @__PURE__ */ N(F, Object.assign({}, i, {
    icon: "facebook",
    className: te(["ShareOnFacebook", s]),
    shareToUrl: "https://www.facebook.com/sharer/sharer.php",
    params: Object.assign({
      u,
      quote: (t = l.document) == null ? void 0 : t.title
    }, n)
  }));
}, In = function(a) {
  var t, r = a.pageUrl, n = a.params, s = a.className, i = re(a, Rn), l = ge(), u = ae(function() {
    return r || Re();
  }, [r]);
  return /* @__PURE__ */ N(F, Object.assign({}, i, {
    icon: "linkedIn",
    className: te(["ShareOnLinkedIn", s]),
    shareToUrl: "https://www.linkedin.com/shareArticle",
    params: Object.assign({
      url: u,
      title: (t = l.document) == null ? void 0 : t.title,
      mini: !0
    }, n)
  }));
}, yn = function(a) {
  var t, r = a.pageUrl, n = a.params, s = a.className, i = re(a, Pn), l = ge(), u = ae(function() {
    return r || Re();
  }, [r]);
  return /* @__PURE__ */ N(F, Object.assign({}, i, {
    icon: "x",
    className: te(["ShareOnTwitter", s]),
    shareToUrl: "https://twitter.com/intent/tweet/",
    params: Object.assign({
      url: u,
      text: (t = l.document) == null ? void 0 : t.title
    }, n)
  }));
}, Un = ["shareToUrl", "params", "title", "tooltipPlacement", "className", "hidden"], Re = function() {
  var a = Mr && qr("URL");
  if (a) {
    var t = new window.URL(window.location.href);
    return t.search = "", t.toString();
  }
}, F = function(a) {
  var t = a.shareToUrl, r = a.params, n = r === void 0 ? {} : r, s = a.title, i = a.tooltipPlacement, l = i === void 0 ? "bottom" : i, u = a.className, c = a.hidden, h = re(a, Un), o = ft(Mr && qr("URL")), f = ae(function() {
    if (!(!o.current || !t)) {
      var v = new window.URL(t);
      return Object.entries(n).forEach(function(L) {
        var x = L[0], H = L[1];
        return v.searchParams.append(x, H);
      }), v.toString();
    }
  }, [t, n]);
  if (!c)
    return /* @__PURE__ */ N(Nt, {
      className: "Share-tooltip",
      title: s,
      placement: l,
      isDisabled: !(s != null && s.trim().length),
      children: /* @__PURE__ */ N(Ot, Object.assign({
        as: "a",
        href: f
      }, h, {
        size: "medium",
        variant: "tertiary",
        className: te(["ShareIcon", u])
      }))
    });
};
F.Facebook = Ln;
F.LinkedIn = In;
F.Twitter = yn;
var Tn = ["pageUrl", "onCopiedText", "className"], $n = /* @__PURE__ */ ht(dt).withConfig({
  displayName: "copyLink__StyledPopupTip",
  componentId: "sc-1dvhluu-0"
})(["&.CopyLinkIcon-popuptip{", ";}"], function(e) {
  var a = e.theme.components.shareLinks;
  return vt(a.PopupTip);
}), ms = function(a) {
  var t = a.pageUrl, r = a.onCopiedText, n = r === void 0 ? "Copied!" : r, s = a.className, i = re(a, Tn), l = ge(), u = ae(function() {
    return t || Re();
  }, [t]), c = function(f) {
    var v;
    i.onClick == null || i.onClick(f), f == null || f.preventDefault(), !(!l.isClient || !u) && ((v = l.window) == null || (v = v.navigator) == null || v.clipboard.writeText(u));
  }, h = function(f) {
    var v;
    i.onKeyDown == null || i.onKeyDown(f), f == null || f.preventDefault(), (f.code === "Enter" || f.code === "Space") && (!l.isClient || !u || (v = l.window) == null || (v = v.navigator) == null || v.clipboard.writeText(u));
  };
  return /* @__PURE__ */ N($n, {
    className: "CopyLinkIcon-popuptip",
    popupTipBody: n,
    hideTitleDivider: !0,
    placement: "bottom",
    timeout: 1e3,
    children: /* @__PURE__ */ N(F, Object.assign({}, i, {
      icon: "link",
      renderAs: "button",
      shareToUrl: "",
      className: te(["CopyLink", s]),
      onClick: c,
      onKeyDown: h,
      "data-testid": "copy-link"
    }))
  });
};
export {
  ms as CopyLink,
  F as ShareIcon,
  Ln as ShareOnFacebook,
  In as ShareOnLinkedIn,
  yn as ShareOnTwitter,
  Re as getCurrentPageUrl
};
